import { useLocation } from "react-router-dom";
import ChannelsCenterFeatureIcon from "@/components/ui/OpticksIcons/ChannelsCenterFeatureIcon";
import OpticksButtonLink from "@/components/ui/OpticksButtonLink/OpticksButtonLink";
import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import type { IntegrationFlow } from "../ChannelIntegrationGuide.types";
import "./FinishUpStep.css";
import "./../../ui/OpticksStepper/OpticksStepper.css";

interface Props {
  flow: IntegrationFlow;
  channelDisplayName: string;
  pixelManagementPath?: string;
}

const FinishUpStep = ({
  flow,
  channelDisplayName,
  pixelManagementPath,
}: Props) => {
  const { pathname } = useLocation();
  const backPath = pathname.replace("/linking", "/overview");

  if (flow === "oauth") {
    return (
      <div className="channels-integration-step finish-up-step">
        <p>
          Your {channelDisplayName} account has been linked successfully.
          Opticks will automatically sync your pixels and start sending
          exclusion events for invalid visits.
        </p>
        {pixelManagementPath && (
          <>You can manage your synced pixels and exclusion settings:</>
        )}
        {pixelManagementPath && (
          <OpticksButtonLink
            size="xs"
            variation="secondary"
            label="Manage pixels"
            to={pixelManagementPath}
          />
        )}
      </div>
    );
  }

  return (
    <div className="channels-integration-step finish-up-step">
      <p>
        Integration finished. Opticks will start sending exclusion events for
        invalid visits to the {channelDisplayName} pixels installed in your
        page.
      </p>
      {pixelManagementPath && (
        <p>
          Alternatively you can manually specify the pixels where you want
          Opticks to send exclusion events by visiting{" "}
          <OpticksLink
            to={pixelManagementPath}
            label="Manage pixels."
            icon={<ChannelsCenterFeatureIcon />}
          />
        </p>
      )}
      {pixelManagementPath && (
        <OpticksButtonLink
          label="Back to channel overview"
          to={backPath}
        />
      )}
    </div>
  );
};

export default FinishUpStep;
